module.exports = __webpack_public_path__ + "img/12.c40da3ba.jpg";